angular.module('natgeo').controller('Level3PlanScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 
function Level3PlanScreen($scope, element, ScreenFactory, manager, container)
{
	var screen = ScreenFactory( 'level3_plan', element );
	
	screen.once('introBefore', function()
	{
		
	});

	// The next screen is the plan screen
	$scope.next = function()
	{
		manager.transition('level3_build');
	};
	
	// The previous screen is the define screen
	$scope.prev = function()
	{
		manager.transition('level3_learn');
	};
	
}]);